import React, { createContext, useContext } from 'react';
import { useMediaQuery } from '@mui/material';

const ScreenSizeContext = createContext();

export const ScreenSizeProvider = ({ children }) => {
  const isSmallScreen = useMediaQuery("(max-width:1200px)");

  return (
    <ScreenSizeContext.Provider value={isSmallScreen}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

export const useScreenSize = () => useContext(ScreenSizeContext);